import { Snackbar, Alert, Backdrop, CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { githubActions } from "../../store";

const GithubLoader = () => {
    const dispatch = useDispatch();
    const loader = useSelector((state) => state.github.loader);
    const snackbar = useSelector((state) => state.github.snackbar);

    const handleSnackbarClose = () => {
        dispatch(githubActions.setSnackbar({ value: { open: false, type: 'success', message: '' } }));
    }

    return (
        <>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                <Alert severity={snackbar.type} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
            <Backdrop
                // sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
                sx={{
                    zIndex: (theme) =>
                        Math.max.apply(Math, Object.values(theme.zIndex)) + 1,
                }}
                open={loader}
            >
                <CircularProgress color="secondary" />
            </Backdrop>
        </>
    );
}

export default GithubLoader;